// const LOCAL_DOMIN = 'http://wxtest.net'
const LOCAL_DOMIN = 'https://api.qdj8.cn'
const DEV_DOMIN = 'https://api.qdj8.cn'
const SIT_DOMIN = 'https://api.qdj8.cn'
const STAGING_DOMIN = 'https://api.qdj8.cn'
const PROD_DOMIN = 'http://api.qdj8.cn'
const PROD_DOMIN_QINIU_XIAOZHAOBAO = 'https://api.qdj8.cn'
const PROD_DOMIN_QINIU_QDJ8 = 'https://api.qdj8.cn'
const PROD_DOMIN_QINIU_WS_QDJ8 = 'https://ws.qdj8.cn'

const LOCAL_ADMIN_DOMIN_URL = 'https://api.qdj8.cn'
const PROD_ADMIN_DOMIN_URL = 'https://www.qdj8.cn'

var currentDomin = LOCAL_DOMIN;
var currentDominWs = LOCAL_DOMIN;
var adminUrlDomin = LOCAL_ADMIN_DOMIN_URL;
if (process.env.CK_ENV === 'production') {
    currentDomin = PROD_DOMIN;
    adminUrlDomin = PROD_ADMIN_DOMIN_URL;
} else if (process.env.CK_ENV === 'production_qiniu_xiaozhaobao') {
    currentDomin = PROD_DOMIN_QINIU_XIAOZHAOBAO;
    currentDominWs = PROD_DOMIN_QINIU_WS_QDJ8;
    adminUrlDomin = PROD_ADMIN_DOMIN_URL;
} else if (process.env.CK_ENV === 'production_qiniu_qdj8') {
    currentDomin = PROD_DOMIN_QINIU_QDJ8;
    currentDominWs = PROD_DOMIN_QINIU_WS_QDJ8;
    adminUrlDomin = PROD_ADMIN_DOMIN_URL;
} else if (process.env.CK_ENV === 'sit') {
    currentDomin = SIT_DOMIN
} else if (process.env.CK_ENV === 'staging') {
    currentDomin = STAGING_DOMIN;
    currentDominWs = STAGING_DOMIN;
} else if (process.env.CK_ENV === 'local') {
    currentDomin = LOCAL_DOMIN
}


const APIV1 = currentDomin + '/api/v1'
const APIV2 = currentDomin + '/api/v2'
const APIMOBILE = currentDomin +'/api/mobile'


module.exports = {
    YQL: [],
    CORS: [SIT_DOMIN, PROD_DOMIN, LOCAL_DOMIN, DEV_DOMIN, STAGING_DOMIN, PROD_DOMIN_QINIU_XIAOZHAOBAO, PROD_DOMIN_QINIU_QDJ8, PROD_DOMIN_QINIU_WS_QDJ8],
    api_domin: currentDomin,
    admin_url_domin: adminUrlDomin,
    api: {

        //登录
        userLogin: `${APIV1}/users/login`,
        thirdPlatformLogin: `${APIV1}/users/oauth/login`,
        thirdPlatformLoginUrl: `${APIV1}/users/oauth/login-url`,
        //登出
        userLogout: `${APIV1}/users/logout`,
        //登录信息
        loginUserInfo: `${APIV1}/users/current`,

        //通知
        broadcast: `${APIV1}/ops/broadcast/:bId`,
        //邀请函背景音乐
        invitationBgm: `${APIV1}/ops/invtbgmusic/:id`,

        //参与人摇奖

        rollpool: `${APIV1}/onsite/rollpool/:poolId`,
        scan: `${APIV1}/onsite/rollpool/:poolId/scan`,
        roll: `${APIV1}/onsite/rollpool/:poolId/roll`,
        winnersPoolItems: `${APIV1}/onsite/rollpool/:poolId/findWinnersPoolItems`,
        receivedItems: `${APIV1}/onsite/rollpool/:poolId/receivedItems`,
        pushRollWinner: `${APIV1}/onsite/rollpool/:poolId/item/:itemId/pushRollWinner`,

        //红包雨
        luckyMoney: `${APIV1}/onsite/luckymoney/:id`,
        preGrab: `${APIV1}/onsite/luckymoney/:id/pre-grab`,
        grab: `${APIV1}/onsite/luckymoney/:id/grab`,
        selfDetails: `${APIV1}/onsite/luckymoney/:id/self-details`,

        //打赏
        reward: `${APIV1}/onsite/reward/:id`,
        rewardTargets: `${APIV1}/onsite/reward/:rewardId/target`,
        rewardDetails: `${APIV1}/onsite/reward/:rewardId/detail`,
        rewardRanking: `${APIV1}/onsite/reward/:rewardId/detail/ranking-list`,

        //会销
        market: `${APIV1}/onsite/market/:id`,
        marketGoods: `${APIV1}/onsite/market/:marketId/goods`,
        marketPurchases: `${APIV1}/onsite/market/:marketId/purchase`,
        marketRankLists: `${APIV1}/onsite/market/:marketId/purchase/rank-list`,


        //竞猜
        guesss: `${APIV1}/onsite/guess`,
        guess: `${APIV1}/onsite/guess/:id`,
        guessRecover: `${APIV1}/onsite/guess/:id/recover`,
        guessTitle: `${APIV1}/onsite/guess/:guessId/title`,
        guessTitleBatch: `${APIV1}/onsite/guess/:guessId/title/batch`,
        guessGoods: `${APIV1}/onsite/guess/:guessId/goods`,
        guessGoodsBatch: `${APIV1}/onsite/guess/:guessId/goods/batch`,
        guessRankingList: `${APIV1}/onsite/guess/:guessId/player/ranking-list`,
        guessPlayer: `${APIV1}/onsite/guess/:guessId/player/default`,
        guessPlayers: `${APIV1}/onsite/guess/:guessId/player`,
        guessAnswerSubmit: `${APIV1}/onsite/guess/:guessId/player/:playerId/submit-one`,
        guessAnswerStart: `${APIV1}/onsite/guess/:guessId/player/:playerId/start`,
        guessAnswerEnd: `${APIV1}/onsite/guess/:guessId/player/:playerId/end`,
        guessAnswerResult: `${APIV1}/onsite/guess/:guessId/player/:playerId/answer-result`,
        guessReceived: `${APIV1}/onsite/guess/:guessId/player/:playerId/received`,
        guessFinish: `${APIV1}/onsite/guess/:id/finish`,
        guessSimple: `${APIV1}/onsite/guess/:id/simple`,
        guessExport: `${APIV1}/onsite/guess/:id/export`,
        guessPlayerDel: `${APIV1}/onsite/guess/:guessId/player/delete`,
        guessPaid: `${APIV1}/onsite/guess/:guessId/goods/:guessGoodsId/paid`,

        //签到墙
        signinwallMessage: `${APIV1}/onsite/signinwall/:id/message`,

        //日志回传
        bankLog: `${APIV1}/core/sys/logging/log`,
        //文件上传
        uploadFile: `${APIV1}/core/sys/files`,
        uploadFileBase64: `${APIMOBILE}/core/sys/files-by-base64`,
        downloadSpecialWordsFile: `${APIV1}/core/sys/files/getSpecialWordsFile`,
        //验证码
        smsCaptcha: `${APIV1}/core/sys/sms-captcha`,
        emailCaptcha: `${APIV1}/core/sys/email-captcha`,
        //系统枚举
        cmenums: `${APIV1}/core/sys/cmenums`,

        //预匹配
        prematchMobile: `${APIV1}/core/sys/sms-captcha/prematch`,
        prematchEmail: `${APIV1}/core/sys/email-captcha/prematch`,
        //
        importOrExportTasks: `${APIV1}/core/sys/tasks`,


        //用户
        usersEnableToken: `${APIV1}/core/users/token/enabled`,
        userInfo: `${APIMOBILE}/core/users/:userId/for-sign-up`,
        user: `${APIV1}/core/users/:id`,
        //手续费率
        feeRate: `${APIV1}/core/users/default/fee-rate`,
        //查询用户填写的报名表单
        userDefault: `${APIV1}/core/users/default`,



        //重置
        resetMobile: `${APIV1}/core/users/default/mobile/reset`,
        resetEmail: `${APIV1}/core/users/default/email/reset`,
        //是否关注签到家
        wxmpSubscribed: `${APIV1}/core/users/wxmp-subscribed`,

        //高级会员判定
        isSMember: `${APIV1}/core/events/:eventId/is-member`,
        //分配管理

        allotExfieldsTicket: `${APIMOBILE}/core/events/:eventId/allocate/tickets/:ticketId`,


        //活动
        eventSimples: `${APIV1}/core/events/simple`,
        events: `${APIV1}/core/events`,
        event: `${APIMOBILE}/core/events/:id`,
        eventSimple: `${APIMOBILE}/core/events/:id/simple`,
        //活动基本信息和配置信息
        eventHeader: `${APIMOBILE}/core/events/:id/header`,
        eventConfig: `${APIMOBILE}/core/events/:id/config`,
        //票务折扣
        ticketingDiscount: `${APIV1}/core/events/:eventId/ticketing/:ticketingId/ticketing-discount`,
        //活动报名表单
        eventForm: `${APIMOBILE}/core/events/:eventId/form`,
        uniqueField: `${APIMOBILE}/core/events/:eventId/form/unique-field`,
        //活动分组
        eventGroups: `${APIMOBILE}/core/events/groups`,
        eventGroupShare: `${APIMOBILE}/core/events/groups/share-style`,

        //分享样式
        shareConfig: `${APIMOBILE}/core/events/:eventId/share`,
        eventImages: `${APIV1}/core/events/:eventId/images`,
        //微信分享营销
        eventWxLevelShare: `${APIV1}/core/events/:eventId/level-share`,
        eventWxLevelShareExp: `${APIV1}/core/events/:eventId/level-share/export`,
        eventWxLevelShareStatis: `${APIV1}/core/events/:eventId/level-share/statistics`,

        //邀请函打开发送统计
        invitationOpened: `${APIV1}/core/events/:eventId/invitees/:inviteeId/invitation-opened`,
        confirmationOpened: `${APIMOBILE}/core/events/:eventId/attendees/:attendeeId/confirmation-opened`,
        //确认函
        confirmation: `${APIMOBILE}/core/events/:eventId/confirmation`,
        confirmationAbsent: `${APIMOBILE}/core/events/:eventId/attendees/:attendeeId/confirmation-absent`,
        confirmationConfirm: `${APIMOBILE}/core/events/:eventId/attendees/:attendeeId/confirmation-confirm`,
        //签到记录
        checkinlogs: `${APIMOBILE}/core/events/:eventId/tickets/checkinlogs`,
        checkinInfoExtend: `${APIMOBILE}/core/events/:eventId/tickets/checkinlogs/:logId/replenish`,
        //签到
        checkinQrcode: `${APIMOBILE}/core/events/:eventId/tickets/checkin`,


        //签到点
        checkinpoint: `${APIMOBILE}/core/events/:eventId/checkinpoints/:id`,
        checkinpoints: `${APIV1}/core/events/:eventId/checkinpoints`,

        //人脸识别
        faceDetect: `${APIV1}/core/face/detect`,

        //详情
        invitation: `${APIV1}/core/events/:eventId/invitees/:inviteeId`,

        //表单查询
        extendForms: `${APIMOBILE}/core/events/:eventId/form`,
        //查询参与人
        attendee: `${APIMOBILE}/core/events/:eventId/attendees/:attendeeId`,
        attendees: `${APIV1}/core/events/:eventId/attendees`,
        attendeesByids: `${APIMOBILE}/core/events/:eventId/attendees/by-ids`,
        attendeeExist: `${APIMOBILE}/core/events/:eventId/attendees/exist`,
        attendeeFormChange: `${APIV1}/core/events/:eventId/form/fill`,

        // 营销渠道
        promotes: `${APIV1}/core/events/:eventId/promotes`,

        //通过唯一标识或手机验证查询门票
        tickets: `${APIMOBILE}/core/events/:eventId/tickets`,
        //找回凭证
        gpbyattds: `${APIMOBILE}/core/events/:eventId/tickets/gpbyattd`,

        //微站
        microsites: `${APIMOBILE}/core/events/:eventId/microsite`,
        micrositeConfig: `${APIMOBILE}/core/events/:eventId/microsite-config`,

        //评论
        eventComments: `${APIV1}/core/events/:eventId/comments`,
        eventComment: `${APIV1}/core/events/:eventId/comments/:id`,
        eventCommentPages: `${APIV1}/core/events/:eventId/comments/page`,
        //投诉
        eventFeedbacks: `${APIV1}/core/events/feedback`,

        //独立问卷
        survey: `${APIV1}/core/survey/:id`,
        surveyAnswers: `${APIV1}/core/survey/:id/answer`,
        surveyUserInfo: `${APIV1}/core/survey/userInfo`,

        //投票
        vote: `${APIV1}/core/vote/:id`,
        votesAnswers: `${APIV1}/core/vote/:id/answer`,
        votesCaptcha: `${APIV1}/core/vote/:id/captcha`,
        votesAnswerName: `${APIV1}/core/vote/:id/check-answer-name`,
        //弹幕
        barrages: `${APIV1}/onsite/barrage`,
        barrageConfig: `${APIV1}/onsite/barrage/config/:configId`,
        //订单计算
        calculatePrice: `${APIMOBILE}/core/orders/calculate-price`,
        orders: `${APIV1}/core/orders`,
        //购票订单列表
        ticketOrders: `${APIMOBILE}/core/orders/ticket`,
        ticketOrdersCreate: `${APIMOBILE}/core/orders/create-for-ticket`,
        //报名并签到
        ticketOrdersCreateAndCheckin: `${APIMOBILE}/core/orders/create-for-ticket-and-checkin`,
        //订单详情
        order: `${APIV1}/core/orders/:orderId`,
        //关闭订单
        orderClose: `${APIV1}/core/orders/:orderId/close`,
        //调起支付
        payinfo: `${APIV1}/core/orders/:_orderId/payinfo`,

        //获取微信签名
        signature: `${APIMOBILE}/core/others/wxmp/jsapi-signature`,
        authcodereport: `${APIV1}/core/thirdAuth/authCodeReport`,
        testMsgSend: `${APIV1}/core/thirdAuth/testMsgSend`,


        //发票列表
        attendeeInvoices: `${APIV1}/core/events/:eventId/attendees-invoice`,
        attendeeInvoiceInfo: `${APIV1}/core/users/default/attendee-invoice`,

    },
    ws: `${currentDominWs}/ws/cm-websocket`,
}



// WEBPACK FOOTER //
// ./src/utils/config.js